import React, { Fragment } from "react";

export function Error404() {
  return (
    <Fragment>
      <div style={{widht:' 100vw', height: '100vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <h1>
          Page not Found.{" "}
          <a href="/" style={{ color: "green" }}>
            Go Back
          </a>
        </h1>
      </div>
    </Fragment>
  );
}
